import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge conditional class names, de-duplicating conflicting Tailwind atoms. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
